export const GET_USER_REQUEST = 'Get user info request'
export const GET_USER_SUCCESS = 'Get user info success'
export const GET_USER_FAILURE = 'Get user info failure'

export const PATH_CHANGE = 'Url has changed';

export const SET_LIVE_TOKEN = 'SET LIVE TOKEN';





// WEBPACK FOOTER //
// ./src/entry_app/actionType.js